import { Link } from 'react-router-dom';
import { resolveFirstAllowedRoute } from '../../shared/access/route-resolver';
import { useAuth } from '../../shared/auth/use-auth';
import { cn } from '../../shared/lib/cn';
import { getButtonClassNames } from '../../shared/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../shared/ui/Card';
import { Stack } from '../../shared/ui/Stack';

export default function ForbiddenPage() {
  const { me } = useAuth();
  const home = resolveFirstAllowedRoute(me?.capabilities ?? null, me);

  return (
    <div className="staff-system-shell">
      <Card className="staff-system-inner">
        <CardHeader>
          <CardTitle>Нет доступа</CardTitle>
          <CardDescription>Этот раздел недоступен в текущей сессии или для вашей роли.</CardDescription>
        </CardHeader>
        <CardContent>
          <Stack gap={4}>
            <Link to={home} className={cn(getButtonClassNames({ variant: 'primary' }), 'staff-link-button')}>
              На доступный раздел
            </Link>
          </Stack>
        </CardContent>
      </Card>
    </div>
  );
}
